import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { BankService } from '@qaroni-app/operations/services/bank.service';
import { OriginService } from '@qaroni-app/operations/services/origin.service';

@Component({
  selector: 'qaroni-layout-values-list',
  standalone: true,
  template: '',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutValuesListComponent implements OnInit {
  private bankService = inject(BankService);
  private originService = inject(OriginService);

  ngOnInit(): void {
    this.bankService.banks();
    this.originService.origins();
  }
}
